import { Component, Input, inject } from "@angular/core";
import { NavbarColor } from "src/app/models/shared-models/navbar-color";
import { SliderItem } from "src/app/models/slider-item.model";
import { SliderItemType } from "../slider.component";
import { ProductCompact } from "src/app/models/shared-models/product.model";
import { PackageType } from "src/app/models/shared-models/package-type.enum";
import { AppImage } from "src/app/models/shared-models/image.model";
import { YumpuDoc } from "../../yumpu-viewer/yumpu-doc.model";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { ScreenSizeService } from "src/app/shared/screen-size.service";
import { NavbarColorDirective } from "src/app/shared/navbar-color.directive";
import { BlurhashDirective } from "src/app/shared/blurhash.directive";
import { SeriesCompactComponent } from "../../shop/series-compact/series-compact.component";
import { ProductCompactComponent } from "../../shop/product-compact/product-compact.component";
import { CoverPlaceholderComponent } from "../../shop/cover-placeholder/cover-placeholder.component";
import { YumpuViewerComponent } from "../../yumpu-viewer/yumpu-viewer.component";
import { FadeOnScrollDirective } from "src/app/shared/fade-on-scroll.directive";

@Component({
  selector: "app-slide",
  templateUrl: "./slide.component.html",
  styleUrls: ["./slide.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    NavbarColorDirective,
    BlurhashDirective,
    SeriesCompactComponent,
    ProductCompactComponent,
    CoverPlaceholderComponent,
    YumpuViewerComponent,
    FadeOnScrollDirective,
  ],
})
export class SlideComponent {
  @Input() slide!: SliderItemType;
  @Input() index!: string;
  @Input() defaultNavbarColor!: NavbarColor;

  PackageType = PackageType;
  private screenSize = inject(ScreenSizeService);

  slideID: string = "";

  constructor() {
    this.slideID = this.generateSlideID();
  }

  getSlideImage(slide: SliderItem): AppImage | undefined {
    // Return mobile image if on mobile and it exists
    if (
      this.screenSize.isMobile() &&
      (slide.mobileImage?.urls?.length ?? 0) > 0
    ) {
      return slide.mobileImage;
    }

    // Fallback to desktop image
    return slide.image;
  }

  hasTransparentNavbar() {
    const slide = this.slide as SliderItem;
    if (slide.navBarColor && slide.navBarColor.background) {
      const background = slide.navBarColor.background;
      return background === "transparent" || background.trim() === "";
    }
    const b = this.defaultNavbarColor?.background;
    return b === "transparent" || b === undefined || b.trim() === "";
  }

  generateSlideID() {
    const randomId = Math.random().toString(36).substring(7);
    return `slide-${this.index}-${randomId}`;
  }

  getProductCompact(): ProductCompact | undefined {
    const product = this.slide as ProductCompact;
    if (product.packageType !== undefined) {
      return product;
    } else {
      return undefined;
    }
  }

  getSliderItem(): SliderItem | undefined {
    const slide = this.slide as SliderItem;
    if (slide.navBarColor !== undefined) {
      return slide;
    } else {
      return undefined;
    }
  }

  getYumpuDoc(): YumpuDoc | undefined {
    const slide = this.slide as unknown as YumpuDoc;
    if (slide.yumpuID !== undefined) {
      return slide;
    } else {
      return undefined;
    }
  }

  getCoverImage(): AppImage | undefined {
    const slide = this.slide as AppImage;
    if (slide.blurHash !== undefined) {
      return slide;
    } else {
      return undefined;
    }
  }

  slideStyle() {
    if (this.getProductCompact()) {
      return {};
      // return {
      //   minWidth: "20rem",
      //   maxWidth: "20rem",
      // };
    }

    const slide = this.slide as SliderItem;
    let style: any = {
      background: slide.navBarColor?.background,
      color: slide.textColor,
    };

    return style;
  }

  // slideImageStyle() {
  //   var style: any = {};

  //   switch (this.slide.imageStyle) {
  //     case "cover":
  //       style.backgroundSize = "cover";
  //       break;
  //     case "contain":
  //       style.backgroundSize = "contain";
  //       break;
  //     case "inline":
  //       style.backgroundSize = "auto";
  //       break;
  //   }
  // }
}
